import React, {useEffect, useState} from 'react';

import AudioPlayer, {RHAP_UI} from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import 'src/styles/components/podcast-player.css';
import {PodcastPlayerForwardButton} from 'src/svgs/podcast-forward';
import {PodcastPlayerRewindButton} from 'src/svgs/podcast-rewind';
// import 'react-h5-audio-player/lib/styles.less' Use LESS
// import 'react-h5-audio-player/src/styles.scss' Use SASS

export type PodcastPlayerProps = {
  megaphoneLink?: string;
};

export const PodcastPlayer: React.FC<PodcastPlayerProps> = props => {
  const [isSticky, setIsSticky] = useState(false);
  const [stickyClass, setStickyClass] = useState('');

  useEffect(() => {
    window.addEventListener('scroll', stickNavbar);

    return () => {
      window.removeEventListener('scroll', stickNavbar);
    };
  }, []);

  const stickNavbar = () => {
    if (window !== undefined) {
      const windowHeight = window.scrollY;
      if (windowHeight > 500) {
        setIsSticky(true);
        setStickyClass('fixed top-10 left-0 pt-8 pb-5 bg-ivory shadow-lg px-10 w-screen z-50');
      } else {
        setIsSticky(false);
        setStickyClass('');
      }
    }
  };

  const layout = isSticky ? 'horizontal' : 'stacked';

  return (
    <div className={stickyClass}>
      <AudioPlayer
        src={props.megaphoneLink}
        showDownloadProgress={false}
        customVolumeControls={[]}
        customAdditionalControls={[]}
        progressJumpSteps={{
          forward: 15000,
          backward: 15000,
        }}
        layout={layout}
        customProgressBarSection={[
          RHAP_UI.CURRENT_TIME,
          <div className="rhap_time" key={props.megaphoneLink}>
            {' '}
            |{' '}
          </div>,
          RHAP_UI.DURATION,
          RHAP_UI.PROGRESS_BAR,
        ]}
        customIcons={{
          rewind: <PodcastPlayerRewindButton />,
          forward: <PodcastPlayerForwardButton />,
        }}
      />
    </div>
  );
};
